import { asyncPool } from './asyncpool';

/** Runs the functions with limited concurrency. Results keep the input order. */
export async function concurrent<T>(
  iteratorFn: (() => Promise<T>)[],
  concurrency: number
): Promise<T[]> {
  const results = new Array<T>(iteratorFn.length);
  await asyncPool.all(
    iteratorFn.map((fn, index) => async () => {
      results[index] = await fn();
    }),
    (fn) => fn(),
    concurrency
  );
  return results;
}
